import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { request as axios } from "./utils/api";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//import element from "./utils/element-registry";
//import HzComponents from "./components/hz";
import "./iconfont/iconfont.css";
import EventBus from "./utils/event";
Vue.use(ElementUI);
Vue.use(HzComponents);
Vue.config.productionTip = false;
Vue.prototype.$EventBus = EventBus;
Vue.prototype.axios = axios;
const protocol = window.location.protocol;
Vue.prototype.$imgURL = `${protocol}//www.jxdinfo.com`;

new Vue({
  router,
  store,
  metaInfo() {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords,
        },
        {
          name: "description",
          content: this.$store.state.metaInfo.description,
        },
      ],
    };
  },
  render: (h) => h(App),
}).$mount("#app");
